export default {
    pcd: "27A",
    pname: "大阪府",
    header: "ゴールドステッカー飲食店応援事業　食事券　申込",
    explanation: "本サイトは、ゴールドステッカー飲食店応援事業　食事券の申込受付サイトです。\nゴールドステッカー飲食店応援事業　食事券の申込方法をご案内しますので、以下に同意したうえでメールアドレスのご登録をお願いいたします。",
    personalinfo: "ご入力いただきました個人情報は、ゴールドステッカー飲食店応援事業　食事券の販売のために使用いたします。\n個人情報は、法令に基づく場合を除き、ご本人様の承諾なしに第三者（弊社業務委託先を除く）に提供することはありません。",
    cid: "eosaka",
    unitdetails: "13,000円（1,000円×12枚　500円×2枚）／1セット",
    ticketvalue: 13000,
    unitprice: 10000,
    maxunits: 2,
    quantityoptions: [
        {value: "1", text: "1"},
        {value: "2", text: "2"}
    ],
    emaillead: "各販売時期毎で1メールアドレスあたり1回のみ、お一人様最大2口までのお申込みになります。",
    starttime: "9:00",
    startdatenotice: {
        title: "第3期受付に関して",
        header: "ゴールドステッカー飲食店応援事業 食事券　第3期受付に関して、以下を確認の上、申込を完了してください",
        alert: "",
        body: "",
        danger: "",
        help: "",
        descriptions: [
            {
                term:"1. 申込について",
                definition: [
                    {text:"各販売時期毎で1メールアドレスあたり1回のみ、お一人様最大2口までのお申込みになります。"}
                ]
            },
            {
                term:"2. 食事券の支払・発券について",
                definition: [
                    {text: "申込完了通知に記載されている引換期限までにファミリーマート店舗で引き換えてください。\n"},
                    {text: "支払・発券期間：申込完了通知に記載\n"},
                    {text: "支払・発券場所：全国のファミリーマート店内のマルチコピー機でレシートを発券後レジにて支払・発券\n"},
                    {text: "※引換開始日は混雑が予想されます。\n　また、店舗が混雑する時間帯（昼11:30～13:30頃、夜 17:00～20:00頃）を避けて\n　ご来店いただけますよう、ご協力をお願いいたします。\n　なお、店舗により発券時間を制限をしている場合があります。\n　引換期限はゆとりをもたせていますので、慌てずに引換えてください。\n"},
                    {text: "※一部 マルチコピー機を設置していない店舗もございます。\n"},
                    {text: "※一時的に食事券用紙在庫が切れる場合がございます。\n"},
                    {text: "※万が一、申込み完了通知が届かない場合は、コールセンター0570-666-609までご連絡ください。"}
                ]
            },
            {
              term:"3. 食事券に関する注意事項",
              definition:[
                  {text: "・お申込みの食事券は大阪府内の登録された利用店舗でのみご利用いただけます。\n"},
                  {text: "・ファミリーマートでのお支払・お受取後の変更、払戻は、いかなる場合でも一切できません。\n"},
                  {text: "・利用店舗によっては利用額などの制限を設けている場合もございますので、事前に必ずご確認ください。\n"},
                  {text: "・食事券ご利用の際、おつりは出ません。\n"}
              ]
          },
          {
              term:"4. 食事券ご利用に際しての感染拡大防止策強化について　",
              definition:[
                  {text: "農林水産省、大坂府の要請により、ゴールドステッカー飲食店応援事業 食事券をご利用頂く際の、\n新型コロナウィルス感染拡大防止策強化について具体策が発表されています。\nご利用いただくお客様におかれましては、以下の注意事項をご確認の上、\nご利用頂きますよう、お願いいたします。\n"},
                  {text: "【食事券を購入・利用される際の３回以上のワクチン接種のお願い】\n"},
                  {text: "これまで、国の新型コロナウイルス感染症対策分科会から、\nワクチン接種をお願いする以下のメッセージが発出されております。\n"},
                  {text: "「若年者でもいわゆる“後遺症”が見られることから、重症化しやすい高齢者はもとより、\n若年者も自らの健康を守るために接種をお願いします。結果として、家族や友人を守ることになります。」\n"},
                  {text: "こちらに基づき、食事券を購入・利用される方におかれましては、\n３回以上のワクチン接種等へのご理解・ご協力をお願いします。\n"},
                  {text: "（参考）\n"},
                  {text: "・令和４年４月８日の分科会メッセージ\n"},
                  {text: "https://www.cas.go.jp/jp/seisaku/ful/taisakusuisin/bunkakai/dai15/kinkyu_message.pdf\n"},
                  {text: "・令和４年7月14日の分科会提言\n"},
                  {text: "https://www.cas.go.jp/jp/seisaku/ful/taisakusuisin/bunkakai/dai17/7thwave_teigen.pdf\n"},
                  {text: "・新型コロナワクチン、追加接種（３回目摂取）についてのお知らせ（厚生労働省）\n"},
                  {text: "https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/vaccine_booster.html\n\n"},
                  {text: "〇感染防止対策（3密の回避、マスク着用、手洗い、こまめな換気等）の徹底\n"},
                  {text: "〇早期のワクチン接種（5～11歳の子どもを含む）を検討すること（法に基づかない働きかけ）\n"},
                  {text: "〇高齢者の命と健康を守るため、高齢者*及び同居家族等日常的に接する方は、\n感染リスクが高い場所への外出・移動を控えること\n"},
                  {text: "*基礎疾患のある方などの重症化リスクの高い方を含む\n"},
                  {text: "〇高齢者施設での面会時は、感染防止対策を徹底すること\n（オンラインでの面会など高齢者との接触を行わない方法を検討すること）\n"},
                  {text: "〇感染対策が徹底されていない飲食店等の利用を控えること\n"},
                  {text: "〇旅行等、都道府県間の移動は、感染防止対策を徹底するとともに、\n移動先での感染リスクの高い行動を控える事\n"},
                  {text: "〇高齢者*の同居家族が感染した場合、高齢者の命を守るため、\n感染対策が取れない方は、積極的に宿泊療養施設において療養すること\n"},
                  {text: "〇会食を行う際は、以下のルールを順守すること\n"},
                  {text: "　・ゴールドステッカー認証店舗を推奨　・マスク会食の徹底　\n"},
                  {text: "*疾患等によりマスクの着用が困難な場合などはこの限りではない\n\n"},
                  {text: "・ご協力いただけないお客様には食事券の利用を控えていただきます。\n"}
              ]
          }
        ],
        footer: ""
    }
};
